import React from 'react';
import colors from '../../../assets/theme/colors';
import LogFormShell from '../../UI/LogFormShell';
import OtherIncidentCapture from './OtherIncidentCapture';
import { getAdaptiveResponseQuickLogConfig } from '../shared/adaptiveQuickLogConfig';

const IncidentLoggingModal = ({
  open,
  onClose,
  child = null,
  childId,
  childName,
  initialData = null,
  mode = 'create',
  entryId = null,
}) => {
  const quickLogConfig = getAdaptiveResponseQuickLogConfig(child);

  return (
    <LogFormShell
      open={open}
      onClose={onClose}
      title={quickLogConfig.sheetTitle}
      titleBadge={childName}
      subtitle={quickLogConfig.sheetSubtitle}
      mobileBreakpoint="sm"
      maxWidth="sm"
      forceDrawer
      titleWeight={700}
      titleSx={{
        fontSize: '20px',
        lineHeight: 1.12,
        letterSpacing: '-0.02em',
        color: colors.semantic.ink,
        maxWidth: 'calc(100% - 94px)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      subtitleSx={{
        mt: 0.75,
        fontSize: '13.5px',
        color: colors.semantic.ink3,
      }}
      titleBadgeSx={{
        bgcolor: colors.semantic.behavior.bg,
        color: colors.semantic.behavior.ink,
        border: `1px solid ${colors.semantic.behavior.bg}`,
        height: 24,
        fontSize: '0.71875rem',
        fontWeight: 600,
        '& .MuiChip-label': {
          px: 1.05,
        },
      }}
      closeButtonSx={{
        width: 32,
        height: 32,
        bgcolor: '#EEF2F0',
        border: 'none',
        '&:hover': {
          bgcolor: '#E6ECE8',
        },
      }}
      closeIconSx={{
        fontSize: 18,
        color: colors.semantic.ink2,
      }}
    >
      <OtherIncidentCapture
        childId={childId}
        childName={childName}
        onSaved={onClose}
        open={open}
        incidentTypeOverride="behavioral"
        initialData={initialData}
        mode={mode}
        entryId={entryId}
        quickLogConfig={quickLogConfig}
      />
    </LogFormShell>
  );
};

export default IncidentLoggingModal;
